export const CAPITULOS = [
  { id: 'c1', nombre: 'Miami, FL', activo: true },
  { id: 'c2', nombre: 'New York, NY', activo: true },
  { id: 'c3', nombre: 'Los Angeles, CA', activo: true },
  { id: 'c4', nombre: 'Austin, TX', activo: true },
];

export const CATEGORIAS_ACADEMIA = [
  'Finanzas',
  'Legal/Migración',
  'Marketing',
  'Networking',
  'Historias de miembros'
];

export const RUBROS = [
  'Tecnología',
  'Legal',
  'Real Estate',
  'Marketing',
  'Diseño',
  'Finanzas',
  'Gastronomía'
];

export const BADGES_INFO = {
  abanderado: {
    id: 'abanderado',
    name: 'Abanderado',
    icon: 'Escarapela',
    description: 'Elegido por votación mensual o admin. Representa los valores de la comunidad.'
  },
  embajador: {
    id: 'embajador',
    name: 'Embajador',
    icon: 'Compass',
    description: 'Top 5 miembros con más invitados en el mes.'
  },
  capitan: {
    id: 'capitan',
    name: 'Capitán',
    icon: 'LifeBuoy',
    description: 'Top 5 por más eventos organizados en el mes.'
  },
  anfitrion: {
    id: 'anfitrion',
    name: 'Anfitrión',
    icon: 'Key',
    description: 'Top 5 por más miembros en los clubes que lideran.'
  },
  estrella: {
    id: 'estrella',
    name: 'Estrella del Mes',
    icon: 'Star',
    description: 'Organizador del evento con más likes/RSVPs del mes.'
  },
  motor: {
    id: 'motor',
    name: 'Motor de la Comunidad',
    icon: 'Settings',
    description: 'Top 5 por mayor volumen de eventos creados en el mes.'
  },
  activo: {
    id: 'activo',
    name: 'Más Activo',
    icon: 'Activity',
    description: 'Top 5 por actividad general en la plataforma (logins, RSVPs, contenido).'
  },
};

export const MOCK_MEMBERS = [
  {
    id: 'm1',
    auth_user_id: 'u1',
    nombre: 'Martín Pérez',
    foto_url: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=200&auto=format&fit=crop',
    capitulo_id: 'c1',
    rubro: 'Tecnología',
    ofrezco: 'Desarrollo de software a medida y consultoría en transformación digital para PyMEs.',
    busco: 'Contactos en Real Estate que necesiten automatizar sus procesos de ventas.',
    whatsapp_number: '+13055550101',
    whatsapp_visible: true,
    role: 'admin',
    status: 'approved',
    invite_code: 'MARTIN-USA',
    badges: [
      { id: 'abanderado', featured: true, expiresAt: '2024-12-31' },
      { id: 'motor', featured: true, expiresAt: '2024-11-30' },
      { id: 'activo', featured: true, expiresAt: '2024-10-31' },
      { id: 'capitan', featured: false, expiresAt: '2024-10-31' }
    ]
  },
  {
    id: 'm2',
    auth_user_id: 'u2',
    nombre: 'Luciana Gómez',
    foto_url: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=200&auto=format&fit=crop',
    capitulo_id: 'c2',
    rubro: 'Legal',
    ofrezco: 'Ayudo a armar LLCs y estructuras fiscales para negocios chicos.',
    busco: 'Emprendedores que recién llegan a USA y necesiten orientación legal.',
    whatsapp_number: '+12125550102',
    whatsapp_visible: true,
    role: 'moderator',
    status: 'approved',
    invite_code: 'LU-LEGAL',
    badges: [
      { id: 'embajador', featured: true, expiresAt: '2024-12-15' },
      { id: 'anfitrion', featured: false, expiresAt: '2024-11-10' }
    ]
  },
  {
    id: 'm3',
    auth_user_id: 'u3',
    nombre: 'Diego Fernández',
    foto_url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=200&auto=format&fit=crop',
    capitulo_id: 'c1',
    rubro: 'Real Estate',
    ofrezco: 'Asesoramiento inmobiliario comercial en el sur de Florida.',
    busco: 'Inversores buscando diversificar en propiedades comerciales.',
    whatsapp_number: '+13055550103',
    whatsapp_visible: false,
    role: 'member',
    status: 'pending',
    invite_code: 'DIEGO-RE',
    badges: [
      { id: 'estrella', featured: true, expiresAt: '2024-12-01' }
    ]
  }
];

export const MOCK_TRAININGS = [
  {
    id: 't1',
    titulo: 'Cómo estructurar tu LLC en 2024',
    descripcion: 'Todo lo que necesitas saber sobre impuestos y responsabilidades legales al abrir tu empresa.',
    categoria: 'Legal/Migración',
    duracion: '45 min',
    presentado_por_member_id: 'm2',
    status: 'approved',
    embed_url: 'https://images.unsplash.com/photo-1589829085413-56de8ae18c73?q=80&w=800&auto=format&fit=crop',
  },
  {
    id: 't2',
    titulo: 'Estrategias de Networking en USA',
    descripcion: 'Diferencias culturales en los negocios y cómo generar confianza rápido.',
    categoria: 'Networking',
    duracion: '30 min',
    presentado_por_member_id: 'm1',
    status: 'pending',
    embed_url: 'https://images.unsplash.com/photo-1515169067868-5387ec356754?q=80&w=800&auto=format&fit=crop',
  }
];

export const MOCK_REELS = [
  {
    id: 'r1',
    titulo: '3 tips rápidos para networking en Miami',
    thumbnail_url: 'https://images.unsplash.com/photo-1515169067868-5387ec356754?q=80&w=400&h=700&auto=format&fit=crop',
    linked_training_id: 't2',
    status: 'approved',
    member_id: 'm1'
  },
  {
    id: 'r2',
    titulo: 'Evitá este error al abrir tu LLC',
    thumbnail_url: 'https://images.unsplash.com/photo-1589829085413-56de8ae18c73?q=80&w=400&h=700&auto=format&fit=crop',
    linked_training_id: 't1',
    status: 'approved',
    member_id: 'm2'
  },
  {
    id: 'r3',
    titulo: 'Mi primer año como freelancer en USA',
    thumbnail_url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=400&h=700&auto=format&fit=crop',
    linked_training_id: null,
    status: 'approved',
    member_id: 'm3'
  },
  {
    id: 'r4',
    titulo: 'Cómo conseguir tu primer cliente local',
    thumbnail_url: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=400&h=700&auto=format&fit=crop',
    linked_training_id: null,
    status: 'pending',
    member_id: 'm2'
  }
];

export const MOCK_CLUBS = [
  {
    id: 'club1',
    nombre: 'Mateada de Miami',
    tipo: 'Mateada',
    capitulo_id: 'c1',
    descripcion: 'Nos juntamos a tomar mate, charlar de negocios y hacer networking relajado cerca de la playa. Traé tu propio equipo y facturas para compartir.',
    foto_portada: 'https://images.unsplash.com/photo-1590412200988-a436970781fa?q=80&w=800&auto=format&fit=crop'
  },
  {
    id: 'club2',
    nombre: 'Asado Tech NY',
    tipo: 'Asado',
    capitulo_id: 'c2',
    descripcion: 'El clásico asado de fin de mes para los que estamos en tecnología en New York. Charlamos de startups, desarrollo y oportunidades.',
    foto_portada: 'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?q=80&w=800&auto=format&fit=crop'
  }
];

export const MOCK_CLUB_SUGGESTIONS = [
  {
    id: 'cs1',
    nombre: 'Pádel Emprendedor Miami',
    descripcion: 'Para juntarnos a jugar al pádel los fines de semana y conectar entre puntos.',
    tipo: 'Otro',
    capitulo_id: 'c1',
    suggested_by_name: 'Diego Fernández'
  },
  {
    id: 'cs2',
    nombre: 'Vino y Negocios NY',
    descripcion: 'Cata de vinos mensual exclusiva para discutir inversiones y alianzas.',
    tipo: 'Otro',
    capitulo_id: 'c2',
    suggested_by_name: 'Martín Pérez'
  }
];

export const MOCK_EVENTOS = [
  {
    id: 'e1',
    titulo: 'Asado de Networking Mensual - Miami',
    descripcion: 'Punto de encuentro para miembros actuales y nuevos. ¡Traé tus tarjetas de presentación!',
    fecha: '2024-12-15T19:00:00Z',
    capitulo_id: 'c1',
    isPast: false,
    club_id: null,
    modalidad: 'Presencial',
    ubicacion: 'Margaret Pace Park, Miami'
  },
  {
    id: 'e2',
    titulo: 'Taller Virtual: Visas O-1 y E-2',
    descripcion: 'Revisión de opciones migratorias para fundadores.',
    fecha: '2023-11-10T18:00:00Z',
    capitulo_id: null,
    recording_training_id: 't1',
    isPast: true,
    club_id: null,
    modalidad: 'Virtual',
    enlace: 'https://zoom.us/j/123456789'
  },
  {
    id: 'e3',
    titulo: 'Mateada #12: Cierre de Año',
    descripcion: 'Última juntada matera del año. Haremos un balance de los logros de la comunidad.',
    fecha: '2024-12-20T16:00:00Z',
    capitulo_id: 'c1',
    isPast: false,
    club_id: 'club1',
    modalidad: 'Presencial',
    ubicacion: 'South Pointe Park, Miami'
  },
  {
    id: 'e4',
    titulo: 'Mateada #11: Bienvenidos',
    descripcion: 'Mateada para recibir a los nuevos miembros llegados en Octubre.',
    fecha: '2024-10-15T16:00:00Z',
    capitulo_id: 'c1',
    isPast: true,
    club_id: 'club1',
    modalidad: 'Presencial',
    ubicacion: 'South Pointe Park, Miami'
  },
  {
    id: 'e5',
    titulo: 'Asado Q3 - Fintech Focus',
    descripcion: 'Este mes nos enfocamos en el sector Fintech y crypto.',
    fecha: '2024-09-30T20:00:00Z',
    capitulo_id: 'c2',
    isPast: true,
    club_id: 'club2',
    modalidad: 'Presencial',
    ubicacion: 'Rooftop Brooklyn, NY'
  }
];

export const MOCK_REPORTED_CONTENT = [
  {
    id: 'rc1',
    content_id: 't1',
    type: 'training',
    titulo: 'Cómo estructurar tu LLC en 2024',
    reported_by_name: 'Diego Fernández',
    reason: 'El autor menciona fees estatales que están desactualizados para Florida.'
  }
];

export const MOCK_REPORTED_MODS = [
  {
    id: 'rm1',
    moderator_id: 'm2',
    moderator_name: 'Luciana Gómez',
    reported_by_name: 'Martín Pérez',
    reason: 'Aprobó perfiles comerciales spam que no cumplen con los lineamientos de la comunidad.'
  }
];

export const MOCK_COMMENTS = [
  { id: 'c1', item_id: 'club1', item_type: 'club', member_id: 'm2', text: '¡Excelente iniciativa! Contá conmigo.', created_at: '2024-10-01T10:00:00Z' },
  { id: 'c2', item_id: 'club1', item_type: 'club', member_id: 'm3', text: 'Llevo facturas.', created_at: '2024-10-02T14:30:00Z' },
  { id: 'c3', item_id: 'e1', item_type: 'evento', member_id: 'm1', text: 'Qué buen evento, ahí nos vemos.', created_at: '2024-11-20T09:15:00Z' }
];

export const MOCK_REACTIONS = [
  { id: 'r1', item_id: 'club1', item_type: 'club', member_id: 'm1' },
  { id: 'r2', item_id: 'club1', item_type: 'club', member_id: 'm2' },
  { id: 'r3', item_id: 'e1', item_type: 'evento', member_id: 'm2' }
];

export const MOCK_COMMENT_REACTIONS = [
  { id: 'cr1', comment_id: 'c1', member_id: 'm1', type: 'mate' },
  { id: 'cr2', comment_id: 'c1', member_id: 'm3', type: 'like' },
  { id: 'cr3', comment_id: 'c2', member_id: 'm2', type: 'haha' },
  { id: 'cr4', comment_id: 'c3', member_id: 'm2', type: 'mano' }
];